exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".andes-tag[data-v-38b5e3a0]{padding:0;border-radius:1px;max-height:26px;font-size:14px;font-weight:400;position:relative;display:inline-block;margin:5px;height:2.1538461538em}.andes-tag .andes-tag__tag-hover-surface[data-v-38b5e3a0]{background-color:hsla(0,0%,80.8%,.5215686274509804);border-radius:2px;height:100%;display:inline-flex;align-items:center}.andes-tag .andes-tag__tag-hover-surface .andes-tag__label[data-v-38b5e3a0]{margin-left:8px;margin-right:3px}", ""]);

// exports
